export enum IngredientMeasurementEnum {
    Gram = 1, Milliliter, Ounce, FluidOunce
}
